import React, { Component } from "react";

import SignIn from "./signIn/signIn";
import Content from "./Contents/content";
import configuration from "./../config.json";

import CookieService from "./../shared/services/cookiesService";

import { withAuth } from "../shared/containers/containerAuth";

import "./app.scss";
import Registration from "./Registration/Registration";
import SwitchRestore from "./Restore/SwitchRestore";

class App extends Component {
  constructor(props) {
    super(props);

    if (!!CookieService.getCookie(configuration.cookieName)) {
      const authData = JSON.parse(CookieService.getCookie(configuration.cookieName));
      const email = authData.email;
      const companyTitle = authData.companyTitle;
      const isNotPayment = authData.isNotPayment;
      const isWinter = authData.isWinter;
      const companyId = authData.companyId;
      const permissions = authData.permissions;
      const userTitle = authData.userTitle;

      this.props.onSetLogin({
        authState: true,
        email,
        companyTitle,
        isNotPayment,
        isWinter,
        companyId,
        permissions,
        userTitle,
      });
    }

    this.setLoginOnFocusBrowserTab = this.setLoginOnFocusBrowserTab.bind(this);
    window.onfocus = this.setLoginOnFocusBrowserTab;
  }

  setLoginOnFocusBrowserTab() {
    if (this.props.authState && !!CookieService.getCookie(configuration.cookieName) === false) {
      this.props.onLogOut();
    } else if (!this.props.authState && !!CookieService.getCookie(configuration.cookieName)) {
      const authData = JSON.parse(CookieService.getCookie(configuration.cookieName));
      const email = authData.email;
      const companyTitle = authData.companyTitle;
      const isNotPayment = authData.isNotPayment;
      const isWinter = authData.isWinter;
      const companyId = authData.companyId;
      const userTitle = authData.userTitle;
      const permissions = authData.permissions;

      this.props.onSetLogin({
        authState: true,
        email,
        companyTitle,
        isNotPayment,
        isWinter,
        companyId,
        userTitle,
        permissions,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { dataState, errors, onClearAuthErrors } = this.props;

    if (!!errors) {
      if (
        (prevProps.dataState === "STATE_REQUEST_LOGIN" && dataState === "STATE_READY_LOGIN") ||
        (prevProps.dataState === "STATE_REQUEST_LOGOUT" && dataState === "STATE_READY_LOGOUT")
      )
        onClearAuthErrors();
    }
  }

  render() {
    const { authState } = this.props;

    if (window.location.pathname === "/Accounts/Restore") {
      return (
        <div>
          <SwitchRestore />
        </div>
      );
    }

    if (window.location.pathname === "/Accounts/Registration") {
      return (
        <div>
          <Registration />
        </div>
      );
    }

    return <div>{!authState ? <SignIn /> : <Content />}</div>;
  }
}

export default withAuth(App);
